import { isEmpty } from "lodash";
import { useRef, useState } from "react";
import gsap from "gsap";

import Link from "next/link";

export default function TitlePart({ menuPart }) {
  if (isEmpty(menuPart)) { return null; }
  const [isOpen, setIsOpen] = useState(false);
  const chevronRef = useRef(null);
  const wrapperRef = useRef(null);

  const handleClick = () => {
    if (isOpen) {
      gsap.to(wrapperRef.current, { height: 0, duration: 0.3 });
    } else {
      gsap.to(wrapperRef.current, { height: 'auto', duration: 0.3 });
    }
    setIsOpen(!isOpen);
  }

  return (
    <div className="footer-menu-part text-white">
      <h4 className="part-title flex items-center justify-between border-b border-white pb-10 lg:border-none font-medium" onClick={handleClick}>
        <span className="part-title-text">{menuPart?.node?.label}</span>
        <div className="chevron-wrapper lg:hidden" ref={chevronRef}>
          <span className="icon icon-chevron text-sm" />
        </div>
      </h4>
      <div className="wrapper-links h-0 overflow-hidden lg:!h-auto" ref={wrapperRef}>
        <ul className="wrapper-links-inner pt-10 pl-4 flex flex-col gap-6 lg:block lg:columns-4 lg:gap-4 lg:pl-0">
          {menuPart?.node?.childItems?.edges?.map((item) => (
            <li className="break-inside-avoid" key={item?.node?.id}>
              <Link
                href={item?.node?.url.replace(process.env.NEXT_PUBLIC_WORDPRESS_SITE, '')}
                className={`menu-link ${item?.node?.cssClasses?.join(' ')} lg:transition-all lg:hover:text-action lg:cursor-pointer`}
                target={item?.node?.target}
                rel={item?.node?.rel}
              >
                {item?.node?.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}